import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormError from '../partials/FormError';
import __ from '../../helpers/translation';

const propTypes = {
  callback: PropTypes.func.isRequired,
  sublocation: PropTypes.object,
  modal: PropTypes.object
};

const SublocationModal = ({ callback, sublocation = null, modal }) => {

  const [ formData, setFormData ] = useState({
    name: sublocation?.name || '',
    description: sublocation?.description || ''
  });

  useEffect(() => {
    if (sublocation) {
      setFormData({
        name: sublocation?.name || '',
        description: sublocation?.description || ''
      });
    } else {
      setFormData({
        name: '',
        description: ''
      });
    }
  }, [sublocation]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  return (
    <div
      className="modal fade"
      id="modalAddSubLocation"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modalAddSubLocation"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div className="modal-content p-3 p-sm-5">
          <div className="modal-header">
            <h1 className="modal-title fw-600" id="exampleModalLongTitle">
              {!sublocation
                ? __('app.inspections.add_sublocation_title')
                : __('app.inspections.edit_sublocation_title', { sublocation: sublocation.name })}
            </h1>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {modal?.errors && <FormError>{modal.errors}</FormError>}
            <form 
              onSubmit={(e) => {
                callback(e, formData);
                setFormData({
                  name: '',
                  description: ''
                }) 
              }}
            >
              <div className="form-group">
                <div className="form-label-group">
                  <input
                    name="name"
                    value={formData?.name}
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    placeholder={__('app.inspections.add_sublocation_input_name')}
                  />
                  <label htmlFor="name">{__('app.inspections.add_sublocation_input_name')}</label>
                </div>
              </div>
              <div className="form-group">
                <textarea
                  name="description"
                  value={formData?.description}
                  onChange={handleChange}
                  className="form-control"
                  id=""
                  cols="30"
                  rows="4"
                  placeholder={__('app.inspections.add_sublocation_input_description')}
                ></textarea>
              </div>
              <button
                type="submit"
                className="btn btn-success d-block w-100 mt-5"
                disabled={modal?.loading}
              >
                {__('app.general.save')}
                {modal?.loading && <i className="far fa-circle-notch fa-spin ml-3"></i>}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

SublocationModal.propTypes = propTypes;

export default SublocationModal;